import React from 'react';
import _ from 'lodash';

import {
  AdministratorsWidgetDocument,
  useAdministratorsWidgetQuery,
  UserStatusName,
  useSaveUserMutation
} from 'generated/graphql';

import { selectFields } from 'modules';



export interface IUser {
  id: string;
  fullName: string;
  email: string;
  status: selectFields.UserStatusSelectField.IUserStatus;
}

export interface IData {
  users: IUser[];
}

export function useQuery() {
  const tuple = useAdministratorsWidgetQuery({
    variables: {}
  });

  return React.useMemo(
    () => {
      const data: IData = {
        users: _.map(tuple.data?.siteUsers.nodes ?? [], (user): IUser => ({
          id: user.id,
          email: user.email,
          fullName: user.fullName,
          status: {
            id: user.status.name,
            displayName: user.status.displayName
          }
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveUser() {
  const [fnMutate, tuple] = useSaveUserMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: AdministratorsWidgetDocument,
        variables: {}
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (id: string, status: UserStatusName) => {
      fnMutate({
        variables: {
          input: {
            id,
            status
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
